import request from '@/utils/request'

//用户登录注册模块
export const userApi = {
  //注册
  register: (data) => request.post('/oauth/account/register', data),
  //获取公钥
  getPublicKey: (params) => request.get('/oauth/rsa/public/key', { params }),
  // 登录
  login: (data) => request.post('/oauth/account/login', data),

}
//我的页面模块
export const myApi = {
  //判断是否填写过全国系统授权信息
  tokenPage: (data) => request.post('/sys/token/page', data),
  //添加全国系统授权信息
  addToken: (data) => request.post('/sys/token', data),
  //危废标签管理(列表)
  labelStatusPage: (data) => request.post('/waste/inventory/status/page', data),
  //危废标签管理(详情/变更记录)
  labelStatusDetails: (data) => request.post('/waste/inventory/log/page', data),
  //同步标签（body：数字识别码 szsbm 字符串数组）
  syncLabelStatus: (data) => request.post('/waste/inventory/status/process/szsbm/batch', data),

  //同步单位信息
  syncData: (params) => request.get('/sys/office/sync/data', { params }),
  //单位基本信息
  officeData: (id) => request.get(`/sys/office/${id}`),
  //业务基本信息(废物信息查询)
  wastePage: (data) => request.post('/waste/waste/info/page', data),
  //业务基本信息(贮存设施查询)
  storagePage: (data) => request.post('/waste/storageinfo/page', data),
  //业务基本信息(管理计划产生信息查询)
  productionPage: (data) => request.post('/waste/production/info/page', data),
  //业务基本信息(管理计划自行利用处置情况查询)
  dispositionPage: (data) => request.post('/waste/disposition/info/page', data),
  //同步废物信息
  syncWasteInfo: () => request.get('/waste/waste/info/sync/data'),
  //同步贮存设施
  syncStorageInfo: () => request.get('/waste/storageinfo/sync/data'),
  //同步管理计划产生信息
  syncProductionInfo: () => request.get('/waste/production/info/sync/data'),
  //同步管理计划自行利用处置/经营单位信息
  syncDispositionInfo: () => request.get('/waste/disposition/info/sync/data'),
  //经办人列表
  operatorPage: (data) => request.post('/waste/operator/info/page', data),
  //新增经办人
  addoperator: (data) => request.post('/waste/operator/info', data),
  //删除经办人
  deloperator: (id) => request.delete(`/waste/operator/info/${id}`),
  //修改经办人
  editoperator: (data) => request.put('/waste/operator/info', data),
  //设备管理列表
  equipmentPage: (data) => request.post('/waste/terminal/device/page', data),
  //修改设备管理状态
  editequipmentStatus: (data) => request.put('/waste/terminal/device', data),
  //删除设备
  delequipment: (id) => request.delete(`/waste/terminal/device/${id}`),
  //添加设备
  addequipment: (data) => request.post('/waste/terminal/device', data),
}



//产生模块
export const generateApi = {
  //产生新的危废单(新增)
  addProduction: (data) => request.post('/waste/production', data),
  //产生新的危废单(修改)
  editProduction: (data) => request.put('/waste/production', data),
  //产生单(列表)
  productionPage: (data) => request.post('/waste/production/page', data),
  //产生单(删除)
  delproduction: (id) => request.delete(`/waste/production/${id}`),
  //产生单(撤销)
  cancelData: (data) => request.post('/waste/production/cancel/data', data),
  //产生单(申报)
  reportdata: (id) => request.get(`/waste/production/report/data/${id}`),
  //产生单(申报失败原因)
  reportStatus: (id) => request.get(`/waste/report/status/biz/${id}`),
}

//入库模块
export const warehousingApi = {
  //添加危废入库单(新增)
  addSavebatch: (data) => request.post('/waste/storage/save/batch', data),
  //危废入库单(列表)
  warehousingPage: (data) => request.post('/waste/storage/page', data),
  //入库单(删除)
  delWarehousing: (id) => request.delete(`/waste/storage/${id}`),
  //入库单(批次删除)
  delWarehousingBatch: (batchNo) => request.delete(`/waste/storage/batch/${batchNo}`),
  //入库单(详情)
  warehousingDetails: (id) => request.get(`/waste/storage/${id}`),
  //入库单(撤销)
  warehousingCancelData: (data) => request.post('/waste/storage/cancel/data', data),
  //入库单(申报)
  warehousingReport: (id) => request.get(`/waste/storage/report/data/${id}`),
  //入库单(按批次号申报)
  warehousingReportBatch: (no) => request.get(`/waste/storage/report/data/batch/${no}`),
  //入库单(批次详情)
  batchgDetails: (batchNo) => request.get(`/waste/storage/batch/no?batchNo=${batchNo}`),
}

//出库模块
export const outboundApi = {
  //添加危废出库单(新增)
  addoutbound: (data) => request.post('/waste/out/storage/save/batch', data),
  //危废出库单(列表)
  outboundPage: (data) => request.post('/waste/out/storage/page', data),
  //联单填领和自行利用处置
  outboundList: (data) => request.post('/waste/out/storage/page/List', data),
  //自行利用处置-出库关联数据分页查询
  outStoragePage: (data) => request.post('/waste/outStorage/page', data),
  //出库单(删除)
  delOutbound: (id) => request.delete(`/waste/out/storage/batch/${id}`),
  //出库单(申报)
  outreportdata: (id) => request.get(`/waste/out/storage/report/data/batch/${id}`),
  //出库单(撤销)
  outCancelData: (data) => request.post('/waste/out/storage/cancel/data', data),
  //出库单(批次详情)
  outbatchgDetails: (batchNo) => request.get(`/waste/out/storage/batch/no?batchNo=${batchNo}`),
}

//自行利用处置模块
export const selfUseApi = {
  //自行利用处置(新增)
  addselfUse: (data) => request.post('/waste/self/dispose', data),
  //自行利用处置(列表)
  selfUsepage: (data) => request.post('/waste/self/dispose/page', data),
  //自行利用处置(申报)
  selfUsereportdata: (id) => request.get(`/waste/self/dispose/report/data/${id}`),
  //自行利用处置(删除)
  delSelfUse: (id) => request.delete(`/waste/self/dispose/${id}`),
  //自行利用处置(撤销)
  selfCancelData: (data) => request.post('/waste/self/dispose/cancel/data', data),
  //自行利用处置(详情)
  selfDetails: (id) => request.get(`/waste/self/dispose/${id}`),
}



//虚拟标签模块
export const virtualApi = {
  //虚拟标签产生(列表)
  virtualProductionPage: (data) => request.post('/waste/virtual/production/page', data),
  //虚拟标签产生(详情)
  virtualProductionDetails: (id) => request.get(`/waste/virtual/production/${id}`),
  //虚拟标签产生(新增-立产立清)
  addVirtualProduction: (data) => request.post('/waste/virtual/production', data),
  //虚拟标签产生(修改)
  editVirtualProduction: (data) => request.put('/waste/virtual/production', data),
  //虚拟标签产生(删除)
  delVirtualProduction: (id) => request.delete(`/waste/virtual/production/${id}`),
  //虚拟标签产生(撤销)
  cancelVirtualProduction: (data) => request.post('/waste/virtual/production/cancel/data', data),
  //虚拟标签产生(申报)
  reportVirtualProduction: (id) => request.get(`/waste/virtual/production/report/data/${id}`),
  //虚拟标签贮存入库(新增)
  addVirtualStorage: (data) => request.post('/waste/virtual/prod/in/storage', data),
  //虚拟标签贮存入库(详情)
  virtualStorageDetails: (id) => request.get(`/waste/virtual/prod/in/storage/${id}`),
  //虚拟标签贮存入库-在库总量(按产废信息统一编号查询)
  virtualStorageTotal: (id) => request.get(`/waste/virtual/prod/in/storage/total/${id}`),
  //虚拟标签贮存入库(修改)
  editVirtualStorage: (data) => request.put('/waste/virtual/prod/in/storage', data),
  //虚拟标签贮存入库(删除)
  delVirtualStorage: (id) => request.delete(`/waste/virtual/prod/in/storage/${id}`),
  //虚拟标签贮存入库(撤销)
  cancelVirtualStorage: (data) => request.post('/waste/virtual/prod/in/storage/cancel/data', data),
  //虚拟标签贮存入库(申报)
  reportVirtualStorage: (id) => request.get(`/waste/virtual/prod/in/storage/report/data/${id}`),
  //虚拟标签-立产立处置(列表)
  virtualSelfDisposePage: (data) => request.post('/waste/virtual/produce/self/dispose/page', data),
  //虚拟标签-立产立处置(新增)
  addVirtualSelfDispose: (data) => request.post('/waste/virtual/produce/self/dispose', data),
  //虚拟标签-立产立处置(修改)
  editVirtualSelfDispose: (data) => request.put('/waste/virtual/produce/self/dispose', data),
  //虚拟标签-立产立处置(详情)
  virtualSelfDisposeDetails: (id) => request.get(`/waste/virtual/produce/self/dispose/${id}`),
  //虚拟标签-立产立处置(删除)
  delVirtualSelfDispose: (id) => request.delete(`/waste/virtual/produce/self/dispose/${id}`),
  //虚拟标签-立产立处置(撤销)
  cancelVirtualSelfDispose: (data) => request.post('/waste/virtual/produce/self/dispose/cancel/data', data),
  //虚拟标签-立产立处置(申报)
  reportVirtualSelfDispose: (id) => request.get(`/waste/virtual/produce/self/dispose/report/data/${id}`),
  //虚拟标签-立产立转移(列表)
  virtualFillOutPage: (data) => request.post('/waste/virtual/produce/fill/out/page', data),
  //虚拟标签-立产立转移(新增)
  addVirtualFillOut: (data) => request.post('/waste/virtual/produce/fill/out', data),
  //虚拟标签-立产立转移(修改)
  editVirtualFillOut: (data) => request.put('/waste/virtual/produce/fill/out', data),
  //虚拟标签-立产立转移(详情)
  virtualFillOutDetails: (id) => request.get(`/waste/virtual/produce/fill/out/${id}`),
  //虚拟标签-立产立转移(删除)
  delVirtualFillOut: (id) => request.delete(`/waste/virtual/produce/fill/out/${id}`),
  //虚拟标签-立产立转移(撤销)
  cancelVirtualFillOut: (data) => request.post('/waste/virtual/produce/fill/out/cancel/data', data),
  //虚拟标签-立产立转移(申报)
  reportVirtualFillOut: (id) => request.get(`/waste/virtual/produce/fill/out/report/data/${id}`),
  //虚拟标签-出库处置(列表)
  virtualOutSelfDisposePage: (data) => request.post('/waste/virtual/out/self/dispose/page', data),
  //虚拟标签-出库处置(详情)
  virtualOutSelfDisposeDetails: (id) => request.get(`/waste/virtual/out/self/dispose/${id}`),
  //虚拟标签-出库处置(新增)
  addVirtualOutSelfDispose: (data) => request.post('/waste/virtual/out/self/dispose', data),
  //虚拟标签-出库处置(修改)
  editVirtualOutSelfDispose: (data) => request.put('/waste/virtual/out/self/dispose', data),
  //虚拟标签-出库处置(撤销)
  cancelVirtualOutSelfDispose: (data) => request.post('/waste/virtual/out/self/dispose/cancel/data', data),
  //虚拟标签-出库处置(删除)
  delVirtualOutSelfDispose: (id) => request.delete(`/waste/virtual/out/self/dispose/${id}`),
  //虚拟标签-出库处置(申报)
  reportVirtualOutSelfDispose: (id) => request.get(`/waste/virtual/out/self/dispose/report/data/${id}`),
  //虚拟标签-出库处置(标签信息/数字身份编码分页)
  virtualOutSelfDisposeLyczSzsbmPage: (data) => request.post('/waste/virtual/out/self/dispose/lycz/szsbm/page', data),
  //虚拟标签-出库转移(列表)
  virtualOutFillOutPage: (data) => request.post('/waste/virtual/out/fill/out/page', data),
  //虚拟标签-出库转移(新增)
  addVirtualOutFillOut: (data) => request.post('/waste/virtual/out/fill/out', data),
  //虚拟标签-出库转移(修改)
  editVirtualOutFillOut: (data) => request.put('/waste/virtual/out/fill/out', data),
  //虚拟标签-出库转移(申报)
  reportVirtualOutFillOut: (id) => request.get(`/waste/virtual/out/fill/out/report/data/${id}`),
  //虚拟标签-出库转移(删除)
  delVirtualOutFillOut: (id) => request.delete(`/waste/virtual/out/fill/out/${id}`),
  //虚拟标签-出库转移(撤销)
  cancelVirtualOutFillOut: (data) => request.post('/waste/virtual/out/fill/out/cancel/data', data),
  //虚拟标签-出库转移(详情)
  virtualOutFillOutDetails: (id) => request.get(`/waste/virtual/out/fill/out/${id}`),
}

//管理台账
export const ledgerApi = {
  //产生台账
  productionData: (data) => request.post('/waste/ledger/production/page', data),
  //入库台账
  storageData: (data) => request.post('/waste/ledger/storage/page', data),
  //自行利用处置台账
  disposeData: (data) => request.post('/waste/ledger/self/dispose/page', data),
  //调整台账
  inventoryData: (data) => request.post('/waste/ledger/adjust/inventory/page', data),
  //利用处置台账
  lyczData: (data) => request.post('/waste/ledger/lycz/page', data),
  //撤销台账
  cancelData: (data) => request.post('/waste/ledger/cancel/page', data),
  //接收入库台账
  jsrkPage: (data) => request.post('/waste/ledger/jsrk/page', data),
  //联单接收台账
  ldjsPage: (data) => request.post('/waste/ledger/ldjs/page', data),
  //创建导出任务
  createExport: (data) => request.post('/waste/excel/export/create', data),
  //下载导出文件
  exportDownload: (taskId, options = {}) => request.get(`/waste/excel/export/download?taskId=${taskId}`, options),
}


//转移联单模块
export const licenceApi = {
  //转移联单--新增--选择转移企业(列表)
  licenceData: (data) => request.post('/waste/licence/page', data),
  //运输单位列表信息
  transportData: (data) => request.post('/waste/transport/page', data),
  // 同步运输单位
  syncTransportData: (params) => request.get('/waste/transport/sync/data', { params }),
  //点击设为常用
  relOffice: (data) => request.post('/waste/transport/rel/office', data),
  //常用运输单位列表
  relOfficepage: (data) => request.post('/waste/transport/rel/office/page', data),
  //点击撤销常用
  relofficeRevoke: (transportId) => request.delete(`/waste/transport/rel/office/${transportId}`),
  //新增联单
  addFillOut: (data) => request.post('/waste/fill/out', data),
  //修改联单
  editFillOut: (data) => request.put('/waste/fill/out', data),
  //管理计划委外利用处置信息同步
  synchronizationReport: (data) => request.post('/waste/licence/report/data', data),
  //转移联单列表
  fillOutPage: (data) => request.post('/waste/fill/out/page', data),
  //删除
  delFillOut: (id) => request.delete(`/waste/fill/out/${id}`),
  //详情
  fillOutDetails: (id) => request.get(`/waste/fill/out/${id}`),
  //点击上报
  fillOutreportData: (id) => request.get(`/waste/fill/out/report/data/${id}`),
  //撤销
  fillOutCancel: (data) => request.post('/waste/fill/out/cancel/data', data),
}


//联单接受入库模块
export const acceptApi = {
  //联单接受入库列表
  storeData: (data) => request.post('/waste/receive/in/store/page', data),
  //点击关联入库列表
  fillOutData: (data) => request.post('/waste/ledger/fill/out/page', data),
  //查询关联联单详情显示在列表
  fillOutShow: (id) => request.get(`/waste/ledger/fill/out/${id}`),
  //同步联单
  fillOutSync: (ldbh) => request.get(`/waste/ledger/fill/out/sync/data?ldbh=${ldbh}`),
  //确认申报/保存
  receiveIn: (data) => request.post('/waste/receive/in/store', data),
  //扫码查询
  qrCodeFind: (data) => request.post('/waste/manifest/no/qr/code/find', data),
  //扫码成功后查询ldbh，查询废物数组数据
  fillOutFind: (ldbh) => request.get(`/waste/ledger/fill/out/find/${ldbh}`),
  //查询联单入库详情
  fillOutDetails: (id) => request.get(`/waste/receive/in/store/${id}`),
  //列表点击接收入库上报
  storeReportData: (id) => request.get(`/waste/receive/in/store/report/data/${id}`),
  //撤销
  storeCancelData: (data) => request.post('/waste/receive/in/store/cancel/data', data),
  //删除
  delReceive: (id) => request.delete(`/waste/receive/in/store/${id}`),
}


//核准联单模块
export const weightApi = {
  //点击新增
  addWeightData: (data) => request.post('/waste/weight', data),
  //核准联单列表
  weightPage: (data) => request.post('/waste/weight/page', data),
  //核准联单详情
  receiveInDetails: (id) => request.get(`/waste/weight/${id}`),
  //修改
  editWeightData: (data) => request.put('/waste/weight', data),
  //点击上报
  reportData: (id) => request.get(`/waste/weight/report/data/${id}`),
  //删除
  deleteWeightData: (id) => request.delete(`/waste/weight/${id}`),
}


//库存查看模块
export const inventoryApi = {
  //库存查看(列表)
  inventoryPage: (data) => request.post('/waste/label/page', data),
  //库存列表(api post)
  inventoryPages: (data) => request.post('/waste/adjust/inventory/page', data),
  adjustInventoryPage: (data) => request.post('/waste/adjust/inventory/page', data),
  //库存调整(更新)
  addAdjust: (data) => request.put('/waste/adjust/inventory', data),
  //库存量汇总查询
  inventorySummary: (params) => request.get('/waste/adjust/inventory/summary', { params }),

}

//访问签名附件
export const imgApi = {
  presigner: (filePath) => request.get(`/sys/upload/file/access/presigner/${filePath}`, { responseType: 'blob' }),
}


//设置页面模块
export const settingApi = {
  //全国系统授权信息获取
  isToken: (id) => request.get(`/sys/token/${id}`),
  //更新全国系统授权信息
  updateToken: (data) => request.put('/sys/token', data),
}


// 通用字典模块
export const dictionaryApi = {
  //通过组id查询字典
  dictionaryItemPage: (data) => request.post('/waste/dictionary/item/page', data),
  //贮存部门经办人/运送部门经办人字典查询
  operatorInfoPage: (data) => request.post('/waste/operator/info/page', data),
}